// extracted by mini-css-extract-plugin
export default {"ownerWrapper":"style_ownerWrapper__AFk3j","avatarCustom":"style_avatarCustom__YqS+x"};